var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExcelIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1042 3.125H8.20002C7.69846 3.125 7.29169 3.53177 7.29169 4.03333V7.81406H15.1042V3.125Z",
    fill: "#169154"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29169 17.2156V20.9667C7.29169 21.4682 7.69846 21.875 8.1995 21.875H15.1042V17.2156H7.29169Z",
    fill: "#18482A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29169 7.81406H15.1042V12.5026H7.29169V7.81406Z",
    fill: "#0C8045"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29169 12.5026H15.1042V17.2161H7.29169V12.5026Z",
    fill: "#17472A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0084 3.125H15.1042V7.81406H22.9167V4.03333C22.9167 3.53177 22.5099 3.125 22.0084 3.125Z",
    fill: "#29C27F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1042 17.2156V21.875H22.0089C22.5099 21.875 22.9167 21.4682 22.9167 20.9672V17.2162H15.1042V17.2156Z",
    fill: "#27663F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1042 7.81406H22.9167V12.5026H15.1042V7.81406Z",
    fill: "#19AC65"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1042 12.5026H22.9167V17.2161H15.1042V12.5026Z",
    fill: "#129652"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6245 17.7083H2.95883C2.4755 17.7083 2.08331 17.3161 2.08331 16.8328V8.16718C2.08331 7.68384 2.4755 7.29166 2.95883 7.29166H11.6245C12.1078 7.29166 12.5 7.68384 12.5 8.16718V16.8328C12.5 17.3161 12.1078 17.7083 11.6245 17.7083Z",
    fill: "#0C7238"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.10784 9.89584H6.35055L7.35888 11.8511L8.42451 9.89584H9.58545L7.98597 12.5L9.6219 15.1042H8.39742L7.29847 13.0573L6.2042 15.1042H4.96149L6.62451 12.4906L5.10784 9.89584Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelIcon);
export default __webpack_public_path__ + "static/media/excel_icon.4e620e943705f3f6f39c1d8f84279399.svg";
export { ForwardRef as ReactComponent };